import { AutenticacionService } from './../../../services/autenticacion.service';
import { CerrarSessionModalComponent } from './../cerrar-session-modal/cerrar-session-modal.component';
import { ConstantsService } from './../../../services/constants.service';
import { Component, OnInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';


declare var $: any;
declare var lottie: any;


interface Colaborador {
  nombre: string;
  foto: string;
  fechaCumple: string; // formato MM-DD
}

@Component({
  selector: 'app-left-sidebar',
  templateUrl: './left-sidebar.component.html',
  styleUrls: ['./left-sidebar.component.scss'],
})
export class LeftSidebarComponent implements OnInit, OnDestroy {

  @ViewChild(CerrarSessionModalComponent)
  public cerrarSessionModal: CerrarSessionModalComponent;

  @ViewChild('lottieLogo') lottieLogo: ElementRef;

  lottieAnim: any;
  isMenuExpanded: boolean = false;
  version: string;
  comentario = '';
  nombreMesActual: string = '';

  public isAdmin = false;
  public isExecutive = false;
  public isUser = false;
  public isGestorGastos = false;
  public isFondeador = false;
  public isEjecutivoFondeador = false;
  public isEjecutivoReportero = false;
  public isCobranza = false;
  public sidebarVisible = true;
  public nombreUsuario: string = '';

  colaboradores: Colaborador[] = [
    { nombre: 'Thania Ruiz Penagos', foto: 'assets/images/colaborador/thania.jpg', fechaCumple: '08-24' },
    { nombre: 'Osiris Fabiola Trejo García', foto: 'assets/images/colaborador/osiris.jpg', fechaCumple: '08-28' },
    { nombre: 'Jose Miguel Avitia Becerra', foto: 'assets/images/colaborador/jose_miguel.jpg', fechaCumple: '09-24' },
    { nombre: 'Doña Tere', foto: 'assets/images/colaborador/tere.jpg', fechaCumple: '10-10' },
    { nombre: 'Angel Ivan Pérez Mendoza', foto: 'assets/images/colaborador/ivan.jpg', fechaCumple: '10-31' },
    { nombre: 'Paola Martinez Mota', foto: 'assets/images/colaborador/pao1.jpg', fechaCumple: '11-07' },
    { nombre: 'Celeste Araceli Gil Escobar', foto: 'assets/images/colaborador/celeste.jpg', fechaCumple: '12-03' },
    { nombre: 'Cleydi Alexis González Méndez', foto: 'assets/images/colaborador/alexis.jpg', fechaCumple: '12-22' },
    { nombre: 'Lic. Alejandro Robles Cordero', foto: 'assets/images/colaborador/alex_robles.jpg', fechaCumple: '01-10' },
    { nombre: 'Luis Enrique Morales González', foto: 'assets/images/colaborador/enrique.jpg', fechaCumple: '02-01' },
    { nombre: 'Rafael Hernández Nieto', foto: 'assets/images/colaborador/rafael.jpg', fechaCumple: '02-15' },
    { nombre: 'Inere Saldaña López', foto: 'assets/images/colaborador/irene.jpg', fechaCumple: '04-05' },
    { nombre: 'Katya Montiel Flores', foto: 'assets/images/colaborador/katya.jpg', fechaCumple: '04-11' },
    { nombre: 'Lucy Gómez Arriaga', foto: 'assets/images/colaborador/lucy.jpg', fechaCumple: '04-17' },
    { nombre: 'Juan Carlos Gutiérrez Gallegos', foto: 'assets/images/colaborador/juan_carlos.jpg', fechaCumple: '04-21' },
    { nombre: 'Marylin Revueltas Ramos', foto: 'assets/images/colaborador/marylin.jpg', fechaCumple: '04-27' },
    { nombre: 'Lic. Andrés Kanter Cordero', foto: 'assets/images/colaborador/andre_kanter.jpg', fechaCumple: '06-04' },
    { nombre: 'Andrea Adé Cabrera', foto: 'assets/images/colaborador/andre.jpg', fechaCumple: '07-06' },
    { nombre: 'Erika Mandujano Solis', foto: 'assets/images/colaborador/erika2.jpg', fechaCumple: '07-13' },
    { nombre: 'Lic. Jose Miguel Kanter Cordero', foto: 'assets/images/colaborador/jose_miguel2.jpg', fechaCumple: '07-27' },
    { nombre: 'Lidia Jovana Ramos Hernández', foto: 'assets/images/colaborador/lidia_jovana.jpg', fechaCumple: '07-29' },
    { nombre: 'KLABE', foto: 'assets/images/colaborador/klabe.png', fechaCumple: '08-05' },
    { nombre: 'KLABE', foto: 'assets/images/colaborador/klabe.png', fechaCumple: '08-06' },

    { nombre: 'Karla Lorena Luján Rivera', foto: 'assets/images/colaborador/karla2.jpg', fechaCumple: '01-14' },
    { nombre: 'Wendy Amairani Ayala López', foto: 'assets/images/colaborador/wendy2.jpg', fechaCumple: '04-20' },
  ];

  contratosMes: any[] = [];
  mostrarBotonContratos: boolean = true;

  cumpleañerosHoy: Colaborador[] = [];
  colaboradorActual: Colaborador | null = null;

  indexActual = 0;
  mostrarBotonCumple = false;
  sliderInterval: any;
  globosAnim: any;

  constructor(
    private constantsService: ConstantsService,
    private authService: AutenticacionService
  ) {
    this.version = 'version ' + constantsService.versionNumber;
    setTimeout(() => {
      this.comentario = 'Creación - Reportes Avance Mensual de Pagos';
    }, 1000);
  }

  initLottieLogo() {
    if (!this.lottieLogo || this.lottieAnim) return;

    this.lottieAnim = lottie.loadAnimation({
      container: this.lottieLogo.nativeElement,
      renderer: 'svg',
      loop: true,       // ✅ loop infinito
      autoplay: true,   // ▶️ arranca solo
      path: 'assets/lottie/arbol.json'
    });

    // 🔒 refuerzo opcional (por si el JSON no trae loop)
    this.lottieAnim.addEventListener('complete', () => {
      this.lottieAnim.goToAndPlay(0, true);
    });
  }


  ngOnInit(): void {
    this.checkUserPermissions();
    this.filtrarCumpleHoy();
    this.setNombreMes();

    const sidebar = localStorage.getItem('sidebar');

    if (sidebar === 'enlarged') {
      // 🔒 Sidebar colapsado → imagen
      this.sidebarVisible = false;
      document.body.classList.add('enlarged');

      this.logoSrc = 'assets/images/klabe2.png';
      this.logoWidth = 35;

    } else {
      // ✅ Sidebar abierto → Lottie
      this.sidebarVisible = true;
      document.body.classList.remove('enlarged');

      this.logoSrc = 'assets/images/logo-klabe.png';
      this.logoWidth = null;

      // ⏱ esperar a que exista el ViewChild
      setTimeout(() => this.initLottieLogo());
    }

    const currentUrl = window.location.pathname;
    if (this.menuItems[0].children.some(child => currentUrl.includes(child.link))) {
      this.isMenuExpanded = true;
    }
    
  }




  logoSrc: string = 'assets/images/logo-klabe.png'; // logo normal
  logoWidth: number | null = null;                  // null usa CSS default

  /** ✅ Toggle correcto del sidebar */
  toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;

    document.body.classList.toggle('enlarged', !this.sidebarVisible);

    localStorage.setItem(
      'sidebar',
      this.sidebarVisible ? 'normal' : 'enlarged'
    );

    if (this.sidebarVisible) {
      // ▶️ Sidebar abierto → Lottie
      this.logoSrc = 'assets/images/logo-klabe.png';
      this.logoWidth = null;

      setTimeout(() => this.initLottieLogo());

    } else {
      // 🧱 Sidebar colapsado → imagen
      this.logoSrc = 'assets/images/klabe2.png';
      this.logoWidth = 35;

      // 🔥 destruir animación
      if (this.lottieAnim) {
        this.lottieAnim.destroy();
        this.lottieAnim = null;
      }
    }
  }




  cerrarSession() {
    this.cerrarSessionModal.open();
  }

  // 🔹 Permisos
  public checkUserPermissions() {
    this.nombreUsuario = this.authService.getNombreUsuario();
    this.isAdmin = this.authService.isAdmin();
    this.isExecutive = this.authService.isExecutive();
    this.isUser = this.authService.isUser();
    this.isGestorGastos = this.authService.isGestorGastos();
    this.isFondeador = this.authService.isFondeador();
    this.isEjecutivoFondeador = this.authService.isEjecutivoFondeador();
    this.isEjecutivoReportero = this.authService.isEjecutivoReportero();
    this.isCobranza = this.authService.isCobranza();
  }

  filtrarCumpleHoy() {
    const hoy = new Date();
    let mes = hoy.getMonth() + 1;
    let dia = hoy.getDate();

    if (hoy.getDay() === 0) {
      const ayer = new Date(hoy);
      ayer.setDate(hoy.getDate() - 1);
      mes = ayer.getMonth() + 1;
      dia = ayer.getDate();
    }

    const fechaHoy = this.pad2(mes) + '-' + this.pad2(dia);

    this.cumpleañerosHoy = this.colaboradores.filter(
      c => c.fechaCumple === fechaHoy
    );

    if (this.cumpleañerosHoy.length > 0) {
      this.mostrarBotonCumple = true;
      this.colaboradorActual = this.cumpleañerosHoy[0];

      if (this.cumpleañerosHoy.length > 1) {
        this.sliderInterval = setInterval(
          () => this.siguienteCumple(),
          10000
        );
      }
    }
  }

  pad2(n: number): string {
    return n < 10 ? '0' + n : '' + n;
  }

  abrirModalCumple() {
    const modal = document.getElementById('modalCumple');
    if (modal) {
      $(modal).modal('show');
      setTimeout(() => this.iniciarGlobos(), 300);
    }
  }

  abrirModalContrato() {
    const modal = document.getElementById('modalContrato');
    if (modal) {
      $(modal).modal('show');
      setTimeout(() => this.iniciarGlobos(), 300);
    }
  }

  siguienteCumple() {
    this.indexActual =
      (this.indexActual + 1) % this.cumpleañerosHoy.length;
    this.colaboradorActual = this.cumpleañerosHoy[this.indexActual];
  }

  ngOnDestroy(): void {
    if (this.globosAnim) cancelAnimationFrame(this.globosAnim);
    if (this.sliderInterval) clearInterval(this.sliderInterval);

    if (this.lottieAnim) {
      this.lottieAnim.destroy();
    }
  }


  iniciarGlobos() {
    const canvas: any = document.getElementById('globos-canvas');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    const colors = ['#FF0000', '#FFAA00', '#00CCFF', '#00FF00', '#FF00FF', '#283481'];
    const globos: any[] = [];

    for (let i = 0; i < 30; i++) {
      globos.push({
        x: Math.random() * canvas.width,
        y: canvas.height + Math.random() * canvas.height,
        r: Math.random() * 20 + 15,
        color: colors[Math.floor(Math.random() * colors.length)],
        speedY: Math.random() + 0.5,
        oscillation: Math.random() * 0.05
      });
    }

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      globos.forEach(b => {
        b.y -= b.speedY;
        b.x += Math.sin(b.y * b.oscillation);

        if (b.y + b.r < 0) {
          b.y = canvas.height + b.r;
          b.x = Math.random() * canvas.width;
        }

        ctx.beginPath();
        ctx.fillStyle = b.color;
        ctx.arc(b.x, b.y, b.r, 0, Math.PI * 2);
        ctx.fill();
      });

      this.globosAnim = requestAnimationFrame(animate);
    };

    animate();
  }


  setNombreMes() {
    const meses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    const fechaActual = new Date();
    this.nombreMesActual = meses[fechaActual.getMonth()];
  }

  menuItems = [
  {
    title: 'Inversiones',
    icon: 'fa fa-users',
    roles: ['admin'],
    children: [
      { title: 'Inversionistas', link: '/inversionistas' },
      { title: 'Pagarés', link: '/inversionistas/pagares' },
      { title: 'Calendario de Pagos', link: '/inversionistas/calendariopagos' },
  
    ]
  }
];
esSubmenuActivo(): boolean {
  return this.menuItems[0].children.some(child => 
    window.location.pathname.includes(child.link)
  );
}
toggleMenu() {
  this.isMenuExpanded = !this.isMenuExpanded;
}
}



// WEBPACK FOOTER //
// ./src/app/components/partials/left-sidebar/left-sidebar.component.ts